import { trackingPageSettingsSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateTrackingPageById = {
  name: "updateTrackingPageById" as const,
  input: z.object({
    id: zExt.objectId(),
    settings: trackingPageSettingsSchema,
  }),
  output: z.object({ success: z.boolean() }),
};
